<template>
    <div>
        <b-card class="shadow mb-5 ml-md-5 mr-md-5 ml-0 mr-0" v-if="!stub">

            <div class="d-flex flex-column w-100 align-items-start justify-content-start">

                <div class="d-flex flex-grow-1 mb-4 mb-xl-0 flex-column w-100">
                    <b-button
                            variant="link"
                            class="flex-grow-0 d-flex align-items-center text-secondary flex-nowrap p-0 mb-4"
                            @click="back()">
                        <b-icon icon="chevron-left" class="mr-2"/>
                        <span>Назад</span>
                    </b-button>

                    <div class="d-flex flex-grow-1 align-items-baseline flex-column flex-sm-row mb-4"
                         :key="objectKey + '-header'">
                        <span class="h3 mb-4 mb-sm-0" v-if="!object.id">Основание для эвтаназии</span>
                        <span class="mb-2 mb-sm-0 mr-3 d-flex flex-column " v-else>
                            <span class="h3">{{ header }}</span>
                        </span>
                        <sup><small v-if="!object.id" class="text-secondary ml-0 ml-sm-2">Новое</small></sup>
                    </div>
                </div>
            </div>

            <div id="form" class="d-flex flex-wrap ml-n3">

                <form-field class="col-xs-4 col-lg-1 required mb-2"
                             :label="getFieldLabel('number')"
                             :editable="getAbility('number')"
                             :value="object.number"
                             :feedback="liveFeedback('number')">
                    <template #field>
                        <b-form-input
                            id="number"
                            class="w-100"
                            type="text"
                            v-model="$v.form.number.$model"
                            :state="validateState('number')">
                        </b-form-input>
                    </template>
                </form-field>

                <form-field class="col-xs-12 col-lg-11 required mb-2"
                             :label="getFieldLabel('name')"
                             :editable="getAbility('name')"
                             :value="object.name"
                             :feedback="liveFeedback('name')">
                    <template #field>
                        <b-form-input
                            id="name"
                            class="w-100"
                            type="text"
                            v-model="$v.form.name.$model"
                            :state="validateState('name')">
                        </b-form-input>
                    </template>
                </form-field>


            </div>

            <object-form-buttons :has-changes="hasChanges"
                 :object-exists="Boolean(object.id)"
                 @object-create="onCreate"
                 @object-update="updateObject"
                 @object-cancel-changes="cancelChanges" class="mb-5"/>

        </b-card>

        <stub :failed-loading="failedLoading" v-else />

        <confirm-leave-modal ref="leaveDialog" :silent-leave="silentLeave" :leave-browser-confirm="hasChanges"/>


    </div>
</template>

<script>
import {ObjectComponentMixin} from "@/components/Forms/ObjectComponentMixin";
import FormField from "@/components/Forms/FormField.vue";
import ObjectFormButtons from "@/components/Forms/ObjectFormButtons.vue";
import Stub from "@/components/Stub.vue";
import ConfirmLeaveModal from "@/components/Forms/ConfirmLeaveModal.vue";
import {EuthanasiaReason} from "@/pages/AppPages/Catalogs/EuthanasiaReasons/euthanasiaReason";
import api from "@/api";

export default {
    name: "EuthanasiaReasonDetail",
    components: {ConfirmLeaveModal, Stub, ObjectFormButtons, FormField},
    mixins: [ ObjectComponentMixin ],
    props: {
        euthanasiaReasonId: null
    },
    beforeMount() {
        this.objectClass = EuthanasiaReason;
        this.objectId = this.euthanasiaReasonId ? this.euthanasiaReasonId : this.$route.params.id;
        this.apiEntryPoint = api.euthanasiaReasons;
        this.backRoute = 'euthanasiaReasonList';
        this.nextRoute = 'euthanasiaReasonDetail';
    },
    mounted() {
        this.onMount();
        this.resetForm();
    },
}
</script>

<style scoped>

</style>